import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Namespace } from 'enums-lib';
import { normalizeHexColor } from 'icon-service-lib';
import { IIconService } from 'interfaces-lib';
import { MessageNotificationService } from 'message-notification-service-lib';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { EntityTypeServiceFactory } from '../../../services/entity-type/entity-type-service.factory';
import { EntityTypeService, IEntityLabelPair } from '../../../services/entity-type/entity-type.service';

@Component({
    selector: 'app-entity-type-picker',
    templateUrl: './entity-type-picker.component.html',
    styleUrls: ['./entity-type-picker.component.scss'],
    standalone: false
})
export class EntityTypePickerComponent implements OnInit {
  @Input() isNewConfig: boolean;
  @Input() configuration: UntypedFormGroup;
  @Input() namespace: Namespace;
  @Input() allowedEntityTypes?: string[];
  entitiesToRender: ({ tooltip: string; iconClass: string; hoverColor: string | null } & IEntityLabelPair)[];
  loadingEntities = false;
  recordLabels: {
    choose: { title: string; tooltip: string };
    chosen: { title: string };
  };
  iconService: IIconService;

  constructor(
    private entityTypeService: EntityTypeService,
    private messageNotificationService: MessageNotificationService,
    private entityTypeServiceFactory: EntityTypeServiceFactory,
    private serviceProviderFactory: SharedServiceProviderServiceFactory
  ) {}

  ngOnInit(): void {
    this.iconService = this.serviceProviderFactory.getServiceProviderService(this.namespace).getIconService();
    this.recordLabels = this.entityTypeServiceFactory.getRecordTypeLabels(this.namespace);

    this.loadingEntities = true;
    this.entityTypeService.getEntitiesForNamespace(this.namespace).subscribe({
      next: (entities) => {
        this.loadingEntities = false;
        this.entitiesToRender = this.entityTypeServiceFactory
          .getMappedEntityTypes(this.namespace, entities)
          .map((elp) => ({
            ...elp,
            tooltip: this.entityTypeServiceFactory.lookupEntityName(this.namespace, elp.objectName),
            iconClass: this.iconService.getIcon(elp.objectName),
            hoverColor: normalizeHexColor(elp.iconColor),
          }))
          .filter((entity) => {
            if (this.allowedEntityTypes && this.allowedEntityTypes.length > 0) {
              return this.allowedEntityTypes.includes(entity.objectName);
            }
            return true;
          })
          .sort((a, b) => a.label.localeCompare(b.label));
        if (!this.isNewConfig) {
          this.entitiesToRender = this.entitiesToRender.filter((entity) => entity.objectName === this.configuration.get('entity').value);
        }
      },
      error: (error) => {
        this.loadingEntities = false;
        this.messageNotificationService.error(`Failed to get entities for entity type picker.`, error);
      },
    });
  }
}
